export function isOperatorVoice(a) {
    return a.attemptTags.some((t) => t.kind === "operator-voice");
}
export function targetSegments(a) {
    return a.segments.filter((s) => s.role === "target");
}
/** Tagged-correct (+½ approximate) / tagged phones. Only over tagged. */
export function attemptAccuracy(a) {
    let tagged = 0;
    let score = 0;
    for (const s of a.segments) {
        if (!s.tag || s.tag.kind === "unclear")
            continue;
        tagged++;
        if (s.tag.kind === "correct")
            score += 1;
        else if (s.tag.kind === "approximate")
            score += 0.5;
    }
    return tagged > 0 ? score / tagged : null;
}
export function summarizeSession(s) {
    var _a;
    const byWord = {};
    let tagged = 0;
    let attempts = 0;
    for (const a of s.attempts) {
        if (isOperatorVoice(a))
            continue;
        attempts++;
        const w = (byWord[_a = a.wordId] ?? (byWord[_a] = {
            attempts: 0,
            taggedCorrect: 0,
            firstCorrectIndex: null,
            accuracy: null,
            starred: 0,
        }));
        w.attempts++;
        if (a.starred)
            w.starred++;
        const targets = targetSegments(a);
        const anyTagged = targets.some((t) => t.tag);
        if (anyTagged)
            tagged++;
        const allCorrect = targets.length > 0 && targets.every((t) => t.tag?.kind === "correct");
        if (allCorrect) {
            w.taggedCorrect++;
            if (w.firstCorrectIndex === null)
                w.firstCorrectIndex = w.attempts;
        }
    }
    for (const [wordId, w] of Object.entries(byWord)) {
        const taggedForWord = s.attempts.filter((a) => a.wordId === wordId &&
            !isOperatorVoice(a) &&
            targetSegments(a).some((t) => t.tag && t.tag.kind !== "unclear")).length;
        w.accuracy = taggedForWord > 0 ? w.taggedCorrect / taggedForWord : null;
    }
    return { byWord, attempts, tagged };
}
